import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import Spinner from 'react-spinkit';
import './../../node_modules/react-spinkit/css/folding-cube.css';

const styles = theme => ({
});

class LoadingScreen extends React.Component {

    render() {
        return (
            <div className={`mam-loading-screen`} elevation={8}>
                <Fade in={true} timeout={250}>
                    <div style={{ paddingTop: 50 }}>
                        <Spinner name="folding-cube" color={"#fff"} className={`mam-spinner`}></Spinner>
                        <div className={`mam-loading-screen-text`}>
                            Searching Loan Options ...
                        </div>
                    </div>
                </Fade>
            </div>
        );
    }
}

LoadingScreen.propTypes = {
};

export default withStyles(styles)(LoadingScreen);